import { render, staticRenderFns } from "./ComponentGeneral.vue?vue&type=template&id=508c7f06"
import script from "./ComponentGeneral.vue?vue&type=script&lang=js"
export * from "./ComponentGeneral.vue?vue&type=script&lang=js"
import style0 from "./ComponentGeneral.vue?vue&type=style&index=0&id=508c7f06&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports